import useLocalStorage from '@/hooks/useLocalStorage';
import { cartDatas } from '@/types/main';
import { getPrice } from '@/utils/getPrice';
import { Image } from '@/components/Image';

export default function CartItem({ cartItemData }: { cartItemData: cartDatas }) {
  const [currency] = useLocalStorage('currency', null);
  return (
    <div
      key={cartItemData.photo_card.id}
      className="w-full px-[30px] py-6 h-[175px] border-b border-[#f5f5f5] flex flex-row items-center gap-4"
    >
      <Image src={cartItemData.photo_card.image} alt="photocard" className="w-[80px] rounded-[12px] object-cover" width={80} />
      <div className="flex-1 flex flex-col justify-between h-full">
        <div className="flex flex-col gap-1">
          <span className="text-[16px] leading-6 font-bold">{`${cartItemData.photo_card.group.name_en} ${
            cartItemData.photo_card.group.name_en === cartItemData.photo_card.member.name_en
              ? ''
              : cartItemData.photo_card.member.name_en
          }`}</span>
          <span className="text-[14px] leading-5 font-normal text-[#808080] w-full overflow-hidden text-ellipsis h-[40px]">
            {cartItemData.photo_card.name_en}
          </span>
        </div>
        {cartItemData.discounted_price > 0 ? (
          <div className="w-full flex flex-row justify-between items-end">
            <span className="text-[16px] font-medium text-[#737373] line-through">
              {getPrice(String(cartItemData.offer.price), currency)}
            </span>
          </div>
        ) : (
          <div />
        )}
        <div
          className={`w-full flex flex-row justify-between items-end ${
            cartItemData.discounted_price > 0 ? 'text-[#E52E2E]' : 'text-black'
          }`}
        >
          <span className="text-[20px] leading-7 font-bold">
            {getPrice(
              String(cartItemData.discounted_price > 0 ? cartItemData.discounted_price : cartItemData.offer.price),
              currency
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
